/* unplugin-vue-components disabled */import { render } from "./carousel.vue?vue&type=template&id=596cd990&scoped=true"
import script from "./carousel.vue?vue&type=script&lang=js"
export * from "./carousel.vue?vue&type=script&lang=js"

import "./carousel.vue?vue&type=style&index=0&id=596cd990&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596cd990"],['__file',"src/controls/carousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "596cd990"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('596cd990', __exports__)) {
    api.reload('596cd990', __exports__)
  }
  
  module.hot.accept("./carousel.vue?vue&type=template&id=596cd990&scoped=true", () => {
    api.rerender('596cd990', render)
  })

}


export default __exports__